/** Administrative divisions and districts of Bangladesh (8 divisions, 64 districts). */

export interface District {
  id: string;
  en: string;
  bn: string;
}

export interface Division {
  id: string;
  en: string;
  bn: string;
  districts: readonly District[];
}

const d = (id: string, en: string, bn: string): District => ({ id, en, bn });

export const DIVISIONS: readonly Division[] = [
  {
    id: "barishal",
    en: "Barishal",
    bn: "বরিশাল",
    districts: [
      d("barguna", "Barguna", "বরগুনা"),
      d("barishal", "Barishal", "বরিশাল"),
      d("bhola", "Bhola", "ভোলা"),
      d("jhalokati", "Jhalokati", "ঝালকাঠি"),
      d("patuakhali", "Patuakhali", "পটুয়াখালী"),
      d("pirojpur", "Pirojpur", "পিরোজপুর"),
    ],
  },
  {
    id: "chattogram",
    en: "Chattogram",
    bn: "চট্টগ্রাম",
    districts: [
      d("bandarban", "Bandarban", "বান্দরবান"),
      d("brahmanbaria", "Brahmanbaria", "ব্রাহ্মণবাড়িয়া"),
      d("chandpur", "Chandpur", "চাঁদপুর"),
      d("chattogram", "Chattogram", "চট্টগ্রাম"),
      d("coxsbazar", "Cox's Bazar", "কক্সবাজার"),
      d("cumilla", "Cumilla", "কুমিল্লা"),
      d("feni", "Feni", "ফেনী"),
      d("khagrachhari", "Khagrachhari", "খাগড়াছড়ি"),
      d("lakshmipur", "Lakshmipur", "লক্ষ্মীপুর"),
      d("noakhali", "Noakhali", "নোয়াখালী"),
      d("rangamati", "Rangamati", "রাঙ্গামাটি"),
    ],
  },
  {
    id: "dhaka",
    en: "Dhaka",
    bn: "ঢাকা",
    districts: [
      d("dhaka", "Dhaka", "ঢাকা"),
      d("faridpur", "Faridpur", "ফরিদপুর"),
      d("gazipur", "Gazipur", "গাজীপুর"),
      d("gopalganj", "Gopalganj", "গোপালগঞ্জ"),
      d("kishoreganj", "Kishoreganj", "কিশোরগঞ্জ"),
      d("madaripur", "Madaripur", "মাদারীপুর"),
      d("manikganj", "Manikganj", "মানিকগঞ্জ"),
      d("munshiganj", "Munshiganj", "মুন্সিগঞ্জ"),
      d("narayanganj", "Narayanganj", "নারায়ণগঞ্জ"),
      d("narsingdi", "Narsingdi", "নরসিংদী"),
      d("rajbari", "Rajbari", "রাজবাড়ী"),
      d("shariatpur", "Shariatpur", "শরীয়তপুর"),
      d("tangail", "Tangail", "টাঙ্গাইল"),
    ],
  },
  {
    id: "khulna",
    en: "Khulna",
    bn: "খুলনা",
    districts: [
      d("bagerhat", "Bagerhat", "বাগেরহাট"),
      d("chuadanga", "Chuadanga", "চুয়াডাঙ্গা"),
      d("jashore", "Jashore", "যশোর"),
      d("jhenaidah", "Jhenaidah", "ঝিনাইদহ"),
      d("khulna", "Khulna", "খুলনা"),
      d("kushtia", "Kushtia", "কুষ্টিয়া"),
      d("magura", "Magura", "মাগুরা"),
      d("meherpur", "Meherpur", "মেহেরপুর"),
      d("narail", "Narail", "নড়াইল"),
      d("satkhira", "Satkhira", "সাতক্ষীরা"),
    ],
  },
  {
    id: "mymensingh",
    en: "Mymensingh",
    bn: "ময়মনসিংহ",
    districts: [
      d("jamalpur", "Jamalpur", "জামালপুর"),
      d("mymensingh", "Mymensingh", "ময়মনসিংহ"),
      d("netrokona", "Netrokona", "নেত্রকোণা"),
      d("sherpur", "Sherpur", "শেরপুর"),
    ],
  },
  {
    id: "rajshahi",
    en: "Rajshahi",
    bn: "রাজশাহী",
    districts: [
      d("bogura", "Bogura", "বগুড়া"),
      d("chapainawabganj", "Chapai Nawabganj", "চাঁপাইনবাবগঞ্জ"),
      d("joypurhat", "Joypurhat", "জয়পুরহাট"),
      d("naogaon", "Naogaon", "নওগাঁ"),
      d("natore", "Natore", "নাটোর"),
      d("pabna", "Pabna", "পাবনা"),
      d("rajshahi", "Rajshahi", "রাজশাহী"),
      d("sirajganj", "Sirajganj", "সিরাজগঞ্জ"),
    ],
  },
  {
    id: "rangpur",
    en: "Rangpur",
    bn: "রংপুর",
    districts: [
      d("dinajpur", "Dinajpur", "দিনাজপুর"),
      d("gaibandha", "Gaibandha", "গাইবান্ধা"),
      d("kurigram", "Kurigram", "কুড়িগ্রাম"),
      d("lalmonirhat", "Lalmonirhat", "লালমনিরহাট"),
      d("nilphamari", "Nilphamari", "নীলফামারী"),
      d("panchagarh", "Panchagarh", "পঞ্চগড়"),
      d("rangpur", "Rangpur", "রংপুর"),
      d("thakurgaon", "Thakurgaon", "ঠাকুরগাঁও"),
    ],
  },
  {
    id: "sylhet",
    en: "Sylhet",
    bn: "সিলেট",
    districts: [
      d("habiganj", "Habiganj", "হবিগঞ্জ"),
      d("moulvibazar", "Moulvibazar", "মৌলভীবাজার"),
      d("sunamganj", "Sunamganj", "সুনামগঞ্জ"),
      d("sylhet", "Sylhet", "সিলেট"),
    ],
  },
];

export function findDistrict(
  divisionId: string,
  districtId: string,
): { division: Division; district: District } | null {
  const division = DIVISIONS.find((v) => v.id === divisionId);
  const district = division?.districts.find((x) => x.id === districtId);
  return division && district ? { division, district } : null;
}

/** District IDs are unique across divisions, so a district alone identifies its division. */
export function findDistrictById(
  districtId: string,
): { division: Division; district: District } | null {
  for (const division of DIVISIONS) {
    const district = division.districts.find((x) => x.id === districtId);
    if (district) return { division, district };
  }
  return null;
}
